import axios from "axios";
import { nonAuthInstance } from "./axiosConfig";

nonAuthInstance.interceptors.request.use((config) => {
  const dbKey = localStorage.getItem("X-DB-KEY");
  if (dbKey) {
    config.headers["X-DB-KEY"] = dbKey;
  }
  return config;
});

const createCancelToken = () => {
  let cancel;
  const token = new axios.CancelToken((c) => {
    cancel = c;
  });
  return { token, cancel };
};

export async function fetchAdmins() {
  try {
    const response = await nonAuthInstance.get("/admin/get/lists");
    return response;
  } catch (error) {
    // Error handling
  }
}

/**
 * 관리자 아이디 중복 체크하기
 * @param {*} admin_id // 관리자 아이디
 * @returns
 */
export async function checkAdminId(admin_id) {
  try {
    const response = await nonAuthInstance.get("/admin/check/" + admin_id);
    return response;
  } catch (error) {
    // Error handling
  }
}

/*
 * 관리자 핸드폰 중복 체크하기
 * @param {*} phone // 관리자 핸드폰
 * @returns
 */
export async function checkPhone(phone) {
  try {
    const response = await nonAuthInstance.get("/admin/phone/" + phone);
    return response;
  } catch (error) {
    // Error handling
  }
}

/**
 * 시스템 환경설정 값을 가져오기
 * @returns
 */
export async function fetchEnvVariables() {
  try {
    const response = await nonAuthInstance.get("/admin/fetch/variables");
    return response;
  } catch (error) {
    // Error handling
    alert("환경설정 가져올 때 서버에 오류 생겼습니다.", error);
    return error;
  }
}

/**
 * 시스템 환경설정 값들을 업데이트하기
 * @param {*} data // request 상세 데이터
 * @returns
 */
export async function updateEvnVariables(data) {
  try {
    var response = await nonAuthInstance.post("/admin/update/variables", data);
    console.log("[update variables][response] => ", response);
    return response;
  } catch (error) {
    console.error("[admind add][error complicated] => ", error);
    alert("환경설정 저장할 때 서버에 오류 생겼습니다.", error);
    return error;
  }
}

/**
 * 관리자 정보 추가하기
 * @param {*} data // request 상세 데이터
 * @returns
 */
export async function addAdmin(data) {
  try {
    var response = await nonAuthInstance.post("/admin/add", data);
    console.log("[add admin][response] => ", response);
    return response;
  } catch (error) {
    console.error("[admind add][error complicated] => ", error);
    alert("관리자 정보 저장할 때 서버에 오류 생겼습니다.", error);
    return error;
  }
}

/**
 * 관리자 정보로 로그인하기
 * @param {*} data
 * @returns // request 상세 데이터
 */
export async function authenticate(data) {
  try {
    const response = await nonAuthInstance.post("/admin/authenticate", data);
    return response;
  } catch (error) {
    // Error handling
  }
}

export async function getAdminLevelCds() {
  try {
    const response = await nonAuthInstance.get("/code/list/admin/level/cd");
    return response;
  } catch (error) {
    // Error handling
  }
}

/**
 * 테스트 이미지 서버에서 가져오기
 * @param {*} imgPath // 이미지 path
 * @returns
 */
export async function fetchImage(imgPath) {
  try {
    return await nonAuthInstance.get("/admin/fetch/image/" + imgPath, {
      method: "GET",
      responseType: "blob",
    });
  } catch (error) {
    // Error handling
  }
}

export async function fetchUrinalysisImages(imgPath) {
  try {
    return await nonAuthInstance.get(
      "/admin/fetch/urinalysis/images/" + imgPath,
      { method: "GET", responseType: "blob" }
    );
  } catch (error) {
    // Error handling
  }
}

/**
 * 회원권 리스트 데이터 가져오기
 * @param {*} data // request 상세 데이터
 * @returns
 */
export async function getCouponList(data) {
  try {
    const response = await nonAuthInstance.post("/coupon/list", data);
    return response;
  } catch (error) {
    // Error handling
  }
}

/**
 * 회원권 리스트 데이터 카운트 가져오기
 * @param {*} data // request 상세 데이터
 * @returns
 */
export async function getCouponListCount(data) {
  try {
    const response = await nonAuthInstance.post("/coupon/list/count", data);
    return response;
  } catch (error) {
    // Error handling
  }
}

/**
 * 회원권 리스트 데이터 카운트 가져오기
 * @param {*} data // request 상세 데이터
 * @returns
 */
export async function publishCouponToAdmin(data) {
  console.log("[publishCouponToAdmin][data] ==> ", data);
  try {
    const { token, cancel } = createCancelToken();
    const response = await nonAuthInstance.post("/coupon/publish", data);
    return { data: response.data, cancel };
  } catch (error) {
    // Error handling
    if (axios.isCancel(error)) {
      console.log("[publishCouponToAdmin] Request canceled : ", error.message);
      return { data: null, error: "Request was canceled" };
    }
    console.log("[publishCouponToAdmin] Request error : ", error);
    return { data: null, error: error.message };
  }
}

/**
 * 관리자 리스트 데이터 가져오기
 * @param {*} data // request 상세 데이터
 * @returns
 */
export async function getAdminList(data) {
  try {
    const response = await nonAuthInstance.post("/admin/list", data);
    return response;
  } catch (error) {
    // Error handling
  }
}

export async function getRemainingCount(userSeq) {
  try {
    const response = await nonAuthInstance.get(
      "/coupon/remaining-count/" + userSeq
    );
    return response;
  } catch (error) {
    // Error handling
  }
}

/**
 * 사용자 리스트 데이터 가져오기
 * @param {*} data // request 상세 데이터
 * @returns
 */
export async function getUserList(data) {
  try {
    const response = await nonAuthInstance.post("/user/list", data);
    return response;
  } catch (error) {
    // Error handling
  }
}

/**
 * 사용자 리스트 데이터 카운트 가져오기
 * @param {*} data // request 상세 데이터
 * @returns
 */
export async function getUserListCount(data) {
  try {
    const response = await nonAuthInstance.post("/user/list/count", data);
    return response;
  } catch (error) {
    // Error handling
  }
}

/**
 * 사용자 상세 정보 가져오기
 * @param {*} userSeq  // 사용자 seq번호
 * @returns
 */
export async function getUserDetails(userSeq) {
  try {
    const response = await nonAuthInstance.get("/user/details/" + userSeq);
    return response;
  } catch (error) {
    // Error handling
  }
}

/**
 * 회원구분(조직) 정보 가져오기
 * @param {*} data
 * @returns
 */
export async function getUserOrgTree(data) {
  try {
    const response = await nonAuthInstance.post("/user/org-tree", data);
    console.log("getUserOrgTree =======>>>",data);
    return response;
  } catch (error) {
    // Error handling
  }
}

/**
 * 사용자 정보 업데이트
 * @param {*} data // 사용자 상세 정보
 * @returns
 */
export async function updateUserDetail(data) {
  try {
    const response = await nonAuthInstance.post("/user/update/detail", data);
    return response;
  } catch (error) {
    // Error handling
  }
}

/**
 * 관리자 관리에서 비밀번호 초기화
 * @param {*} data 사용자 상세 정보
 * @returns
 */
export async function resetPassword(data) {
  try {
    var response = await nonAuthInstance.post("/user/update/pass", data);
    console.log("[resetPassword][response] => ", response);
    return response;
  } catch (error) {
    console.error("[resetPassword][error complicated] => ", error);
    return error;
  }
}

export async function getUserResetDevice(userSeq) {
  try {
    const response = await nonAuthInstance.get("/user/reset/device/" + userSeq);
    return response;
  } catch (error) {
    // Error handling
  }
}

/**
 * 회원 계정 활동/변경 이력(audit log) 목록 조회
 * @param {*} requestObj { user_seq, page_size, page_number }
 * @returns
 */
export async function getUserActivityLog(requestObj) {
  try {
    const response = await nonAuthInstance.post("/user/activity-log/list", requestObj);
    return response;
  } catch (error) {
    // Error handling
  }
}

/**
 * 회원 계정 활동/변경 이력(audit log) 총 건수
 * @param {*} requestObj { user_seq, page_size, page_number }
 * @returns
 */
export async function getUserActivityLogCount(requestObj) {
  try {
    const response = await nonAuthInstance.post("/user/activity-log/list/count", requestObj);
    return response;
  } catch (error) {
    // Error handling
  }
}

/**
 * 회원 계정 잠금 해제 (관리자 전용)
 * @param {*} data { user_seq }
 * @returns
 */
export async function unlockUser(data) {
  try {
    const response = await nonAuthInstance.post("/user/unlock", data);
    return response;
  } catch (error) {
    // Error handling
  }
}

/**
 * 관리자 비밀번호 초기화 함수
 * @param {*} data 관리자 seqNum 및 비ㅣ밀번호
 * @returns
 */
export async function resetAdminPass(data) {
  try {
    var response = await nonAuthInstance.post("/admin/reset/pass", data);
    console.log("[resetAdminPass][response] => ", response);
    return response;
  } catch (error) {
    console.error("[resetAdminPass][error complicated] => ", error);
    return error;
  }
}

/**
 * 관리자 관리에 회원권 회수하는 end point
 * @param {*} data
 * @returns
 */
export async function recoveryRequest(data) {
  try {
    const response = await nonAuthInstance.post("/coupon/recovery", data);
    return response;
  } catch (error) {
    // Error handling
  }
}

export async function addNotice(data) {
  try {
    const response = await nonAuthInstance.post("/main/notice/add", data);
    return response;
  } catch (error) {
    // Error handling
  }
}

export async function updateNotice(data) {
  try {
    const response = await nonAuthInstance.post("/main/notice/update", data);
    return response;
  } catch (error) {
    // Error handling
  }
}

export async function getNotices(data) {
  try {
    const response = await nonAuthInstance.post(
      "/main/notice/paging/list",
      data
    );
    return response;
  } catch (error) {
    // Error handling
  }
}

export async function getNoticeCount(data) {
  try {
    const response = await nonAuthInstance.post(
      "/main/notice/paging/count",
      data
    );
    return response;
  } catch (error) {
    // Error handling
  }
}

export async function getNoticeDetail(seq) {
  try {
    const response = await nonAuthInstance.get("/main/notice/" + seq);
    return response;
  } catch (error) {
    // Error handling
  }
}

// 회원가입 통계
export async function getTestStats(data) {
  try {
    const response = await nonAuthInstance.get("/test/stats", { params: data });
    return response;
  } catch (error) {
    // Error handling
  }
}

export async function getCouponHistoryList(requestObj) {
  try {
    const response = await nonAuthInstance.post(
      "/coupon/history/list",
      requestObj
    );
    return response;
  } catch (error) {
    // Error handling
  }
}

export async function getCouponHistoryListCount(requestObj) {
  try {
    const response = await nonAuthInstance.post(
      "/coupon/history/list/count",
      requestObj
    );
    return response;
  } catch (error) {
    // Error handling
  }
}

// Issue
// export async function getIssues(data) {
//     try {
//         const response = await nonAuthInstance.get("/main/issue/list", data);
//         return response;
//     } catch (error) {
//         // Error handling
//     }
// }

export async function addIssue(data) {
  try {
    const response = await nonAuthInstance.post("/main/issue/add", data);
    return response;
  } catch (error) {
    // Error handling
  }
}

export async function getIssueDetail(seq) {
  try {
    const response = await nonAuthInstance.get("/main/issue/" + seq);
    return response;
  } catch (error) {
    // Error handling
  }
}

export async function updateIssue(data) {
  try {
    const response = await nonAuthInstance.post("/main/issue/update", data);
    return response;
  } catch (error) {
    // Error handling
  }
}

export async function getIssueCount(data) {
  try {
    const response = await nonAuthInstance.post(
      "/main/issue/paging/count",
      data
    );
    return response;
  } catch (error) {
    // Error handling
  }
}

export async function getIssues(data) {
  try {
    const response = await nonAuthInstance.post(
      "/main/issue/paging/list",
      data
    );
    return response;
  } catch (error) {
    // Error handling
  }
}

export async function getChart(daychart) {
  try {
    const response = await nonAuthInstance.get("/test/day/chart", {
      params: daychart,
    });
    return response;
  } catch (error) {
    // Error handling
  }
}

export async function getMemberChart(periodType) {
  try {
    const response = await nonAuthInstance.get("/test/day/member/chart", {
      params: periodType,
    });
    return response;
  } catch (error) {
    // Error handling
  }
}

// 회원가입 수
export async function getMemberNo(periodType) {
  try {
    const response = await nonAuthInstance.get("/test/no/member", {
      params: periodType,
    });
    return response;
  } catch (error) {
    // Error handling
  }
}

export async function getUriStripManagement(request) {
  console.log("🚀 ~ getUriStripManagement ~ request:", request);
  try {
    const { token, cancel } = createCancelToken();
    const response = await nonAuthInstance.get(
      `/strip/find/uri/management/${request.custSeq}/${request.stripId}/${request.groupCode}`,
      { cancelToken: token }
    );
    return { data: response.data, cancel };
  } catch (error) {
    // Error handling
    if (axios.isCancel(error)) {
      console.log("[getUriStripManagement] Request canceled : ", error.message);
      return { data: null, error: "Request was canceled" };
    }
    console.log("[getUriStripManagement] Request error : ", error);
    return { data: null, error: error.message };
  }
}

export async function getStripInfos() {
  try {
    const { token, cancel } = createCancelToken();
    const response = await nonAuthInstance.get(`/strip/infos`, {
      cancelToken: token,
    });
    return { data: response.data, cancel };
  } catch (error) {
    // Error handling
    if (axios.isCancel(error)) {
      console.log("[getStripInfos] Request canceled : ", error.message);
      return { data: null, error: "Request was canceled" };
    }
    console.log("[getStripInfos] Request error : ", error);
    return { data: null, error: error.message };
  }
}

export async function getStripItems(request) {
  try {
    const { token, cancel } = createCancelToken();
    const response = await nonAuthInstance.get(`/strip/items`, {
      params: request,
      cancelToken: token,
    });
    return { data: response.data, cancel };
  } catch (error) {
    // Error handling
    if (axios.isCancel(error)) {
      console.log("[getStripItems] Request canceled : ", error.message);
      return { data: null, error: "Request was canceled" };
    }
    console.log("[getStripItems] Request error : ", error);
    return { data: null, error: error.message };
  }
}

export async function updateStripDetails({ data }) {
  console.log("[updateStripDetails][data] ==> ", data);
  try {
    const { token, cancel } = createCancelToken();
    const response = await nonAuthInstance.put("/strip/uri/details", data);
    return { data: response.data, cancel };
  } catch (error) {
    // Error handling
    if (axios.isCancel(error)) {
      console.log("[updateStripDetails] Request canceled : ", error.message);
      return { data: null, error: "Request was canceled" };
    }
    console.log("[updateStripDetails] Request error : ", error);
    return { data: null, error: error.message };
  }
}

export async function updateStripDetailRanges({ data }) {
  console.log("[updateStripDetailRanges][data] ==> ", data);
  try {
    const { token, cancel } = createCancelToken();
    const response = await nonAuthInstance.patch("/strip/detail/ranges", data);
    return { data: response.data, cancel };
  } catch (error) {
    // Error handling
    if (axios.isCancel(error)) {
      console.log(
        "[updateStripDetailRanges] Request canceled : ",
        error.message
      );
      return { data: null, error: "Request was canceled" };
    }
    console.log("[updateStripDetailRanges] Request error : ", error);
    return { data: null, error: error.message };
  }
}

export async function getStripDetailRanges(request) {
  try {
    const { token, cancel } = createCancelToken();
    const response = await nonAuthInstance.get(`/strip/detail/ranges`, {
      params: request,
      cancelToken: token,
    });
    return { data: response.data, cancel };
  } catch (error) {
    // Error handling
    if (axios.isCancel(error)) {
      console.log("[getStripDetailRanges] Request canceled : ", error.message);
      return { data: null, error: "Request was canceled" };
    }
    console.log("[getStripDetailRanges] Request error : ", error);
    return { data: null, error: error.message };
  }
}

export async function getAdminDetails(adminSeq) {
  try {
    const { token, cancel } = createCancelToken();
    const response = await nonAuthInstance.get(
      "/admin/search/adminSeq?adminSeq=" + adminSeq,
      { cancelToken: token }
    );
    return { data: response.data, cancel };
  } catch (error) {
    // Error handling
    if (axios.isCancel(error)) {
      console.log("[getAdminDetails] Request canceled : ", error.message);
      return { data: null, error: "Request was canceled" };
    }
    console.log("[getAdminDetails] Request error : ", error);
    return { data: null, error: error.message };
  }
}

/**
 * 조직도 관리 Insert or Update
 * @param {*} data
 */
export async function getOrgUnits(data) {
  try {
    const token = localStorage.getItem('token');
    console.log("getOrgUnits data=======>>>",data);
    const response = await nonAuthInstance.post("/org/units", data, {
            headers: {
                Authorization: token ? `Bearer ${token}` : undefined
            }
        });
    console.log("getOrgUnits response=======>>>", response);
  } catch (error) {
    console.error("getOrgUnits Error:", {
            status: error.response?.status,
            data: error.response?.data,
            message: error.message
        });
        throw error;
  }
}

export async function getOrgCouponPolicy(source_org_id) {
  try {
    const response = await nonAuthInstance.get("/org/coupon-policy", {params: {
      sourceOrgId: source_org_id
    }});
    return response;
  } catch (error) {
    // Error handling
  }
}

export async function getOrgHistory(target_org_id) {
  try {
    const response = await nonAuthInstance.get("/org/history", {params: {
      targetOrgId: target_org_id
    }});
    return response;
  } catch (error) {
    // Error handling
  }
}

export async function checkAvailableDelOrg(org_id) {
  try {
    const response = await nonAuthInstance.get("/org/"+org_id+"/available");
    return response;
  } catch (error) {
    // Error handling
  }
}

export async function deleteOrgUnit(org_id) {
  try {
    const response = await nonAuthInstance.delete("/org/delete/"+org_id);
    return response;
  } catch (error) {
    // Error handling
  }
}

export async function encryptQr() {
  try {
    const response = await nonAuthInstance.put("/coupon/qr/encrypt")
    return response;
  } catch (error) {
  }
}